import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { Badge } from '../../elements/ui/badge';
import { HealthSystemDomainDeviceResultReaderViewModel } from '../../api/HealthSystemApi';
import { getReaderStatus, formatLastSeen } from '../../utils/readerStatus';
import { useTranslation } from 'react-i18next';

interface ReaderHealthBadgeProps {
  reader: HealthSystemDomainDeviceResultReaderViewModel;
}

const variantMap = {
  healthy: 'success',
  stale: 'warning',
  down: 'danger'
} as const;

const labelKeyMap = {
  healthy: 'f-reader-health-healthy',
  stale: 'f-reader-health-stale',
  down: 'f-reader-health-down'
} as const;

const ReaderHealthBadge: React.FC<ReaderHealthBadgeProps> = ({ reader }) => {
  const { t } = useTranslation();
  const status = getReaderStatus(reader);
  const relative = formatLastSeen(reader.lastHeartbeatAt);
  const absolute = reader.lastHeartbeatAt
    ? new Date(reader.lastHeartbeatAt).toLocaleString()
    : t('f-reader-never-seen');

  return (
    <Tooltip
      arrow
      title={
        <span>
          {t('f-reader-last-seen')}: {relative}
          <br />
          <span style={{ opacity: 0.75, fontSize: '0.75em' }}>{absolute}</span>
        </span>
      }
    >
      <span>
        <Badge variant={variantMap[status]}>{t(labelKeyMap[status])}</Badge>
      </span>
    </Tooltip>
  );
};

export default ReaderHealthBadge;
